module.exports = __webpack_public_path__ + "1fd212df8aef4e335bf7a541400a223c.svg";